import Swiper from 'swiper';
import type { SwiperOptions } from 'swiper/types';
import { Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';

export interface HomeNewResidentSwiperWidgetOptions {
  rootSelector?: string;
  swiperOptions?: Partial<SwiperOptions>;
}

const defaultSwiperOptions = {
  modules: [Autoplay, EffectFade],
  centeredSlides: false,
  slidesPerView: 1,
  simulateTouch: false,
  grabCursor: false,
  autoplay: {
    delay: 6000,
    disableOnInteraction: false,
    pauseOnMouseEnter: true,
    waitForTransition: true,
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  speed: 1300,
  loop: false,
  rewind: true,
} satisfies Partial<SwiperOptions>;

export class HomeNewResidentSwiperWidget {
  private readonly root: HTMLElement | null;
  private swiper: Swiper | null = null;
  private readonly extraOptions: Partial<SwiperOptions>;

  constructor(options?: HomeNewResidentSwiperWidgetOptions) {
    this.root = document.querySelector<HTMLElement>(
      options?.rootSelector ?? '.new-resident__swiper-box',
    );
    this.extraOptions = options?.swiperOptions ?? {};
  }

  public init(): void {
    if (!this.root) return;

    const el = this.root.querySelector<HTMLElement>('.swiper');

    if (!el) return;

    this.destroy();

    this.swiper = new Swiper(el, {
      ...defaultSwiperOptions,
      ...this.extraOptions,
      modules: this.extraOptions.modules ?? defaultSwiperOptions.modules,
    });
  }

  public destroy(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}
